<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"> </p>
<p class="ser"> </p>
<p class="ser"> </p>
<p class="tx1">I will tell you what not to <i>say</i>, but I will not tell you what not to <i>think</i>. Think whatever you like.</p>
<p class="ser"> </p>
<p class="tx1">Let’s review.</p>
<p class="ser"> </p>
<p class="tx1">THOUGHTS are the things on the In side of your head. They are invisible. Your thoughts are yours. No one else’s. No one else wants them. </p>
<p class="ser"> </p>
<p class="tx1">WORDS are the things that exit your hole to the Out side of your head, where we are. They are a lot like thoughts, except that we can hear them. We don’t want most of those, either. You can keep them.</p>
<p class="ser"> </p>
<p class="tx1">Here is every word that you should keep to yourself.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// intro2.vue?9a3fcf80